export default "__VITE_ASSET__QeizURv2__"